export default function toFriendlyUrl(str, noTrim = false) {
    let out = str.toLowerCase();
    out = out.replace(/&/g, " and ");
    out = out.replace(/@/g, " at ");
    out = out.replace(/[,'"]/g, "");
    out = out.replace(/[^a-z0-9]+/g, "-");
    out = out.replace(/-+/g, "-");
    if (!noTrim) {
        out = out.replace(/(^-+)|(-+$)/g, '');
    }
    return out;
}
